/**
 * assets/patch-pop-bundle-product.js
 *
 * Independent JS for sections/patch-pop-bundle-product.liquid only.
 * Does NOT use Dawn's product-form, product-info, or variant-selects.
 * Does NOT depend on bundle-picker.js.
 *
 * Patch theme picker changes (all other code is unchanged):
 *  - Native <select> is kept hidden as a data source and state mirror.
 *  - Custom trigger button opens a desktop panel or mobile bottom sheet.
 *  - JS reads option[data-gid/data-title/data-image] from the hidden select.
 *  - After a pick, JS sets select.value = numericId so that updateTray()
 *    (which queries ".ppb-patch-select[data-slot='N'] option[value='numericId']")
 *    still resolves title and image correctly.
 *  - state model, updateTray, refreshValidationMessage, refreshAtcButton,
 *    buildComponents, syncDropdownAvailability, and _bundle_components payload
 *    are all 100% unchanged.
 *
 * Desktop vs mobile:
 *  - Breakpoint: 750px (matches Dawn's tablet breakpoint).
 *  - Desktop: .ppb-picker-panel opens as an absolute dropdown below the trigger.
 *  - Mobile:  .ppb-picker-sheet slides up as a bottom sheet with .ppb-picker-backdrop.
 *  - Detection is done at click time; no server-side branching needed.
 *
 * allowRepeated handling (unchanged logic, new DOM targets):
 *  - allowRepeated=false: syncDropdownAvailability adds .ppb-picker-option--taken
 *    to options already selected in OTHER slots. Taken options are non-clickable.
 *  - allowRepeated=true: no cross-slot disabling.
 */

(function () {
  "use strict";

  // Mobile breakpoint matching Dawn's $grid-breakpoint-md
  var MOBILE_BP = 750;

  document.querySelectorAll("[id^='PatchPopBundle-']").forEach(function (sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    var dataEl = document.getElementById("ppb-rule-data-" + sectionId);
    if (!dataEl) return;

    var ruleData;
    try {
      ruleData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error("[PatchPop] Could not parse rule data for section " + sectionId, e);
      return;
    }

    if (!ruleData.components || ruleData.components.length === 0) return;

    // ── State ────────────────────────────────────────────────────────────────
    // selections[role][slot] = full GID string | null
    //   base_product : slot 1 only, quantity always 1
    //   patch_theme  : slots 1..requiredQty
    var state = {
      quantity:   1,
      selections: {}
    };

    ruleData.components.forEach(function (group) {
      state.selections[group.role] = {};
      for (var s = 1; s <= group.requiredQty; s++) {
        state.selections[group.role][s] = null;
      }
    });

    // ── DOM refs ─────────────────────────────────────────────────────────────
    // currentBundleImageUrl: updated by switchBundleGallery on each base
    // color change; read by the ATC handler to add _bundle_image to atcProperties.
    var currentBundleImageUrl = null;

    var atcBtn    = document.getElementById("ppb-atc-"        + sectionId);
    var errorBox  = document.getElementById("ppb-error-"      + sectionId);
    var errorText = document.getElementById("ppb-error-text-" + sectionId);
    var qtyInput  = document.getElementById("ppb-qty-"        + sectionId);
    var qtyMinus  = document.getElementById("ppb-qty-minus-"  + sectionId);
    var qtyPlus   = document.getElementById("ppb-qty-plus-"   + sectionId);

    // ── Quantity stepper ─────────────────────────────────────────────────────
    if (qtyMinus) {
      qtyMinus.addEventListener("click", function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) { qtyInput.value = v - 1; state.quantity = v - 1; }
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener("click", function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
        state.quantity = v + 1;
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        var v = parseInt(this.value, 10);
        if (!v || v < 1) { this.value = 1; v = 1; }
        state.quantity = v;
      });
    }

    // ── Base product groups ──────────────────────────────────────────────────
    sectionEl.querySelectorAll(".ppb-group--base").forEach(function (groupEl) {
      var role = groupEl.dataset.role;

      groupEl.querySelectorAll(".ppb-base-product").forEach(function (productEl) {

        var variantsScriptEl = productEl.querySelector(".ppb-variants-json");
        if (!variantsScriptEl) {
          console.error("[PatchPop] .ppb-variants-json script tag not found inside .ppb-base-product");
          return;
        }

        var variants;
        try {
          variants = JSON.parse(variantsScriptEl.textContent);
        } catch (e) {
          console.error("[PatchPop] Could not parse variants JSON from .ppb-variants-json", e);
          return;
        }

        if (!Array.isArray(variants) || variants.length === 0) {
          console.error("[PatchPop] Variants JSON is empty or not an array");
          return;
        }

        var variantMap = {};
        variants.forEach(function (v) {
          if (Array.isArray(v.options)) {
            variantMap[v.options.join("|")] = v;
          }
        });

        var optionCount = 0;
        var selectedOptions = {};
        productEl.querySelectorAll(".ppb-option-fieldset").forEach(function (fs) {
          var idx     = parseInt(fs.dataset.optionIndex, 10);
          var checked = fs.querySelector("input[type='radio']:checked");
          selectedOptions[idx] = checked ? checked.value : null;
        });
        optionCount = Object.keys(selectedOptions).length;

        function buildVariantKey() {
          var parts = [];
          for (var i = 0; i < optionCount; i++) {
            parts.push(selectedOptions[i] !== null ? selectedOptions[i] : "");
          }
          return parts.join("|");
        }

        function resolveCurrentVariant() {
          var key = buildVariantKey();
          return variantMap.hasOwnProperty(key) ? variantMap[key] : null;
        }

        function applyVariantState() {
          var variant           = resolveCurrentVariant();
          var unavailableNotice = productEl.querySelector(".ppb-unavailable-notice");

          if (variant) {
            productEl.dataset.variantId = String(variant.id);
            productEl.dataset.available = String(variant.available);

            if (variant.available) {
              state.selections[role][1] = variant.gid;
              if (unavailableNotice) unavailableNotice.hidden = true;
            } else {
              state.selections[role][1] = null;
              if (unavailableNotice) unavailableNotice.hidden = false;
            }
          } else {
            productEl.dataset.variantId = "";
            productEl.dataset.available = "false";
            state.selections[role][1]   = null;
            if (unavailableNotice) unavailableNotice.hidden = true;
          }

          markUnavailableOptions(productEl, variants, variantMap, selectedOptions, optionCount);
          refreshValidationMessage(sectionEl, role, ruleData, state);
          refreshAtcButton(atcBtn, ruleData, state);
          currentBundleImageUrl = switchBundleGallery(sectionEl, productEl) || null;
        }

        productEl.querySelectorAll(".ppb-option-fieldset").forEach(function (fs) {
          var optIdx = parseInt(fs.dataset.optionIndex, 10);

          fs.querySelectorAll("input[type='radio']").forEach(function (radio) {
            radio.addEventListener("change", function () {
              selectedOptions[optIdx] = this.value;

              var legendValueSpan = fs.querySelector(".ppb-selected-option-val");
              if (legendValueSpan) {
                legendValueSpan.textContent = this.value;
              }

              applyVariantState();
            });
          });
        });

        applyVariantState();
      });
    });

    // ── Gallery switch on base color change (Route 1: alt-text matching) ─────
    //
    // When the customer picks a base color, find the parent bundle product's
    // gallery image whose alt text is "bundle-color-{normalizedColor}" and
    // activate it via media-gallery.setActiveMedia().
    // Returns the matched <img>.src string so the ATC handler can store it
    // as _bundle_image on the line item for cart/notification/drawer image override.
    //
    // Normalization: lowercase, spaces to hyphens, strip non-alphanumeric/hyphen.
    // Example: "Off White" -> "off-white" -> "bundle-color-off-white"
    //
    // Safe exits (all return null silently):
    //   - No Color/Colour fieldset in productEl
    //   - No radio checked
    //   - <media-gallery> absent or setActiveMedia not a function
    //   - No img[alt="bundle-color-{color}"] in gallery viewer
    //   - No [data-media-id] ancestor above matched img
    function switchBundleGallery(secEl, productEl) {
      // 1. Find the Color/Colour option fieldset.
      var colorFieldset = null;
      productEl.querySelectorAll(".ppb-option-fieldset").forEach(function (fs) {
        var name = (fs.dataset.optionName || "").toLowerCase();
        if (name === "color" || name === "colour") { colorFieldset = fs; }
      });
      if (!colorFieldset) return null;

      // 2. Read the checked radio value.
      var checkedRadio = colorFieldset.querySelector("input[type='radio']:checked");
      if (!checkedRadio) return null;

      // 3. Normalize: lowercase, spaces to hyphens, strip non-alphanumeric/hyphen.
      var normalized = checkedRadio.value
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

      // 4. Build expected alt string.
      var targetAlt = "bundle-color-" + normalized;

      // 5. Find <media-gallery> and guard setActiveMedia.
      var galleryEl = secEl.querySelector("media-gallery");
      if (!galleryEl) return null;
      if (typeof galleryEl.setActiveMedia !== "function") return null;

      // 6. Find matching <img> by alt inside the gallery viewer.
      var viewer = galleryEl.querySelector("[id^='GalleryViewer']");
      if (!viewer) return null;
      var matchingImg = viewer.querySelector("img[alt='" + targetAlt + "']");
      if (!matchingImg) return null;

      // 7. Walk up to [data-media-id] ancestor.
      var mediaItem = matchingImg.closest("[data-media-id]");
      if (!mediaItem) return null;

      // 8. Activate in gallery and return the image URL for _bundle_image.
      galleryEl.setActiveMedia(mediaItem.dataset.mediaId, false);
      return matchingImg.src;
    }

    // ── Patch theme groups ───────────────────────────────────────────────────
    sectionEl.querySelectorAll(".ppb-group--patches").forEach(function (groupEl) {
      var role     = groupEl.dataset.role;
      var reqQty   = parseInt(groupEl.dataset.requiredQty, 10) || 1;
      var allowRep = groupEl.dataset.allowRepeated === "true";
      var trayEl   = document.getElementById("ppb-tray-" + role);

      // ── Picker open/close helpers ─────────────────────────────────────────

      function isMobile() {
        return window.innerWidth < MOBILE_BP;
      }

      // Close all open pickers in this group (across all slots and both modes)
      function closeAllPickers(exceptSlot) {
        groupEl.querySelectorAll(".ppb-patch-slot").forEach(function (slotEl) {
          var s = parseInt(slotEl.dataset.slot, 10);
          if (exceptSlot !== undefined && s === exceptSlot) return;
          closePicker(slotEl);
        });
      }

      function openPicker(slotEl) {
        closeAllPickers(parseInt(slotEl.dataset.slot, 10));

        var trigger  = slotEl.querySelector(".ppb-picker-trigger");
        var panel    = slotEl.querySelector(".ppb-picker-panel");
        var backdrop = slotEl.querySelector(".ppb-picker-backdrop");
        var sheet    = slotEl.querySelector(".ppb-picker-sheet");

        if (isMobile()) {
          // Mobile bottom sheet
          if (backdrop) backdrop.classList.add("ppb-picker-backdrop--open");
          if (sheet)    sheet.classList.add("ppb-picker-sheet--open");
          document.body.style.overflow = "hidden";
        } else {
          // Desktop dropdown panel
          if (panel) {
            panel.hidden = false;
            panel.removeAttribute("hidden");
          }
        }

        if (trigger) trigger.setAttribute("aria-expanded", "true");
      }

      function closePicker(slotEl) {
        var trigger  = slotEl.querySelector(".ppb-picker-trigger");
        var panel    = slotEl.querySelector(".ppb-picker-panel");
        var backdrop = slotEl.querySelector(".ppb-picker-backdrop");
        var sheet    = slotEl.querySelector(".ppb-picker-sheet");

        if (panel) {
          panel.hidden = true;
        }
        if (backdrop) backdrop.classList.remove("ppb-picker-backdrop--open");
        if (sheet)    sheet.classList.remove("ppb-picker-sheet--open");
        if (trigger)  trigger.setAttribute("aria-expanded", "false");

        // Only restore scroll if no other sheets are open anywhere on the page
        var anySheetOpen = document.querySelector(".ppb-picker-sheet--open");
        if (!anySheetOpen) {
          document.body.style.overflow = "";
        }
      }

      // ── Apply a selection (called after any pick) ─────────────────────────
      // numericId : the option value (pv.id as string)
      // gid       : "gid://shopify/ProductVariant/..."
      // title     : patch product title
      // imgSrc    : CDN image URL or empty string
      // slotNum   : integer slot index (1-based)
      // slotEl    : the .ppb-patch-slot element

      function applyPick(numericId, gid, title, imgSrc, slotNum, slotEl) {
        // allowRepeated=false: reject if this GID is already chosen in another slot
        if (!allowRep && gid) {
          var conflict = false;
          Object.keys(state.selections[role]).forEach(function (s) {
            if (parseInt(s, 10) !== slotNum && state.selections[role][s] === gid) {
              conflict = true;
            }
          });

          if (conflict) {
            showError(errorBox, errorText,
              "You've already selected this patch in another slot. Please choose a different patch.");
            closePicker(slotEl);
            return;
          }
        }

        clearError(errorBox);

        // Update state
        state.selections[role][slotNum] = gid || null;

        // Mirror to hidden select so updateTray() can still find the option by value
        var hiddenSelect = groupEl.querySelector(
          ".ppb-patch-select[data-slot='" + slotNum + "']"
        );
        if (hiddenSelect) {
          hiddenSelect.value = numericId || "";
        }

        // Update trigger button appearance
        var trigger   = slotEl.querySelector(".ppb-picker-trigger");
        var imgWrap   = trigger ? trigger.querySelector(".ppb-trigger-img-wrap")  : null;
        var textSpan  = trigger ? trigger.querySelector(".ppb-trigger-text")      : null;

        if (gid) {
          if (textSpan)  textSpan.textContent = title || gid;
          if (imgWrap) {
            imgWrap.innerHTML = "";
            if (imgSrc) {
              var img     = document.createElement("img");
              img.src     = imgSrc;
              img.alt     = title || "";
              img.width   = 24;
              img.height  = 24;
              imgWrap.appendChild(img);
            }
            imgWrap.hidden = !imgSrc;
          }
        } else {
          if (textSpan)  textSpan.textContent = trigger ? trigger.dataset.placeholder : "— Select patch —";
          if (imgWrap)   { imgWrap.innerHTML = ""; imgWrap.hidden = true; }
        }

        // Mark selected state on option <li> elements in both panel and sheet
        slotEl.querySelectorAll(".ppb-picker-option").forEach(function (li) {
          var isThis = (li.dataset.value === numericId && numericId !== "");
          li.setAttribute("aria-selected", isThis ? "true" : "false");
          li.classList.toggle("ppb-picker-option--selected", isThis);
        });

        // Cross-slot availability (allowRepeated=false only)
        if (!allowRep) {
          syncPickerAvailability(groupEl, role, slotNum, state);
        }

        updateTray(trayEl, groupEl, role, state, reqQty);
        refreshValidationMessage(sectionEl, role, ruleData, state);
        refreshAtcButton(atcBtn, ruleData, state);

        closePicker(slotEl);
      }

      // ── Wire each slot ────────────────────────────────────────────────────
      groupEl.querySelectorAll(".ppb-patch-slot").forEach(function (slotEl) {
        var slotNum = parseInt(slotEl.dataset.slot, 10);

        // Trigger button click → open picker
        var trigger = slotEl.querySelector(".ppb-picker-trigger");
        if (trigger) {
          trigger.addEventListener("click", function (e) {
            e.stopPropagation();
            var isOpen = this.getAttribute("aria-expanded") === "true";
            if (isOpen) {
              closePicker(slotEl);
            } else {
              openPicker(slotEl);
            }
          });
        }

        // Desktop panel: click on an option
        var panel = slotEl.querySelector(".ppb-picker-panel");
        if (panel) {
          panel.addEventListener("click", function (e) {
            e.stopPropagation();
            var li = e.target.closest(".ppb-picker-option");
            if (!li) return;
            if (li.classList.contains("ppb-picker-option--unavailable")) return;
            if (li.classList.contains("ppb-picker-option--taken")) return;
            applyPick(
              li.dataset.value,
              li.dataset.gid,
              li.dataset.title,
              li.dataset.image,
              slotNum,
              slotEl
            );
          });
        }

        // Mobile sheet: click on an option
        var sheet = slotEl.querySelector(".ppb-picker-sheet");
        if (sheet) {
          sheet.addEventListener("click", function (e) {
            e.stopPropagation();
            var li = e.target.closest(".ppb-picker-option");
            if (li) {
              if (li.classList.contains("ppb-picker-option--unavailable")) return;
              if (li.classList.contains("ppb-picker-option--taken")) return;
              applyPick(
                li.dataset.value,
                li.dataset.gid,
                li.dataset.title,
                li.dataset.image,
                slotNum,
                slotEl
              );
              return;
            }
          });

          // Sheet close button
          var closeBtn = sheet.querySelector(".ppb-sheet-close");
          if (closeBtn) {
            closeBtn.addEventListener("click", function (e) {
              e.stopPropagation();
              closePicker(slotEl);
            });
          }
        }

        // Mobile backdrop click → close sheet
        var backdrop = slotEl.querySelector(".ppb-picker-backdrop");
        if (backdrop) {
          backdrop.addEventListener("click", function () {
            closePicker(slotEl);
          });
        }
      });

      // Document click → close desktop panels (outside click)
      document.addEventListener("click", function () {
        groupEl.querySelectorAll(".ppb-patch-slot").forEach(function (slotEl) {
          var panel = slotEl.querySelector(".ppb-picker-panel");
          if (panel && !panel.hidden) {
            closePicker(slotEl);
          }
        });
      });

      // Init validation message for patch groups
      refreshValidationMessage(sectionEl, role, ruleData, state);
    });

    // Init ATC button state (disabled until all groups complete)
    refreshAtcButton(atcBtn, ruleData, state);

    // ── Add to cart ──────────────────────────────────────────────────────────
    if (atcBtn) {
      atcBtn.addEventListener("click", async function () {
        clearError(errorBox);

        var validationErr = getValidationError(ruleData, state);
        if (validationErr) {
          showError(errorBox, errorText, validationErr);
          return;
        }

        var components        = buildComponents(ruleData, state);
        var displayComponents = buildDisplayComponents(ruleData, state, sectionEl);
        setAtcLoading(atcBtn, true);

        // Build properties object. _bundle_components_display is added when
        // buildDisplayComponents succeeds; if it throws for any reason the
        // try/catch below still sends the working _bundle_components payload.
        var atcProperties = {
          _bundle_components: JSON.stringify(components),
          _bundle_rule_id:    ruleData.ruleId,
          _bundle_label:      ruleData.ruleName || "Bundle"
        };
        if (displayComponents) {
          atcProperties._bundle_components_display = displayComponents;
        }
        if (currentBundleImageUrl) {
          atcProperties._bundle_image = currentBundleImageUrl;
        }

        // ── Detect Dawn cart element: drawer takes priority, then notification ─
        // Both cart-drawer and cart-notification expose identical APIs:
        //   getSectionsToRender() and renderContents(parsedState).
        // Whichever is present in the DOM reflects the active theme setting.
        // Switching the theme setting between drawer and notification requires
        // no code change here — detection is fully automatic.
        var cartEl              = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
        var hasSectionsToRender = cartEl && typeof cartEl.getSectionsToRender === "function";
        var hasRenderContents   = cartEl && typeof cartEl.renderContents      === "function";
        var hasSectionRendering = hasSectionsToRender && hasRenderContents;

        // ── Build the /cart/add.js request body ───────────────────────────────
        // Use the SINGLE-ITEM format (flat keys at root, no "items" array) so
        // the response has a top-level `.key` field that Dawn's renderContents
        // reads as `parsedState.key` when registering the cart item key.
        // The "items" array format returns per-item keys only inside items[],
        // not at the response root, which causes renderContents to silently fail.
        //
        // _bundle_components, _bundle_components_display, and all other
        // properties are completely unchanged — only the request wrapper differs.
        var requestBody = {
          id:         parseInt(ruleData.parentVariantId, 10),
          quantity:   state.quantity,
          properties: atcProperties
        };

        if (hasSectionRendering) {
          // This Dawn version's renderContents looks up parsedState.sections[section.id]
          // (not section.section). Shopify's /cart/add.js sections API keys its response
          // by the IDs sent in the request, so the request must use s.id to match.
          // Using s.section sends template-scoped IDs (e.g. 'template--123__cart-drawer')
          // that don't match section.id inside renderContents, causing a null.innerHTML
          // TypeError when getSectionInnerHTML tries to parse the missing section HTML.
          requestBody.sections     = cartEl.getSectionsToRender().map(function (s) { return s.id; });
          requestBody.sections_url = window.location.pathname;

          // FIX 2: Register the triggering element before the async fetch.
          // Dawn's product-form.js calls cart.setActiveElement(document.activeElement)
          // before submitting. This stores the ATC button so CartDrawer.open() can pass
          // it to trapFocus for keyboard accessibility. Without it, open() receives null
          // as activeElement, which causes trapFocus to crash in some Dawn versions and
          // leaves the drawer inaccessible via keyboard in all versions.
          // Called here (pre-fetch, pre-await) so document.activeElement is still the
          // button that triggered the click.
          if (typeof cartEl.setActiveElement === "function") {
            cartEl.setActiveElement(document.activeElement);
          }
        }

        // PATCHPOP START — /cart/add.js with single-retry + poisoned-bundle recovery
        // A poisoned bundle line already in the cart makes Shopify reject EVERY
        // /cart/add.js with HTTP 422 (cart-wide validation). We retry exactly
        // once after re-reading /cart.js; if it still 422s we show explicit,
        // non-"sold out" recovery UI with an "Empty cart & try again" action.
        // ppbDidRetry guarantees at most one retry — no loop, even on rapid
        // re-clicks (the button is also disabled via setAtcLoading during flight).
        var ppbDidRetry = false;

        var ppbDoAdd = async function () {
          // Locale-safe endpoint (matches the clear-cart path): build from the
          // Shopify routes root so market/locale prefixes (e.g. /en-eg/) are
          // respected. Falls back to "/" if the global is unavailable.
          var ppbRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
          var res = await fetch(ppbRoot + "cart/add.js", {
            method:  "POST",
            headers: { "Content-Type": "application/json" },
            body:    JSON.stringify(requestBody)
          });

          var parsedResponse = {};
          try { parsedResponse = await res.json(); } catch (_) {}

          if (!res.ok) {
            // 422 = poisoned-bundle cart rejection. Retry once, then recover.
            if (res.status === 422 && !ppbDidRetry) {
              ppbDidRetry = true;
              // Re-read cart state once (matches the documented retry pattern),
              // then re-attempt the identical add a single time.
              try { await fetch(window.Shopify.routes.root + "cart.js"); } catch (_) {}
              return ppbDoAdd();
            }
            if (res.status === 422) {
              // Retry already used and still 422 → explicit recovery UI.
              ppbShowAddRecovery(errorBox, errorText);
              setAtcLoading(atcBtn, false);
              return;
            }
            // Any other non-OK status → generic, recoverable message.
            showError(errorBox, errorText,
              parsedResponse.description || "Could not add to cart. Please try again.");
            setAtcLoading(atcBtn, false);
            return;
          }

          // ── Trigger Dawn cart element (drawer or notification) ────────────
          // parsedResponse is the raw /cart/add.js response. When sections were
          // requested, Shopify injects parsedResponse.sections (sectionId →
          // rendered HTML) which renderContents reads directly.
          // cart-drawer.renderContents() also calls this.open() automatically.
          // Safe fallback: log the specific failure reason, then redirect.
          var usedNotification = false;

          // FIX 3: Re-query the live cart element after the fetch.
          // The pre-fetch cartEl reference is valid for building requestBody.sections
          // but must not be used for renderContents. During the await, Dawn may replace
          // the <cart-drawer> element when transitioning from is-empty to active state
          // (i.e. the very first item added to an empty cart). Calling renderContents
          // or open() on the now-detached old node causes this.querySelector('#CartDrawer')
          // to return null inside CartDrawer.open(), crashing trapFocus with:
          //   TypeError: Cannot read properties of null (reading 'querySelectorAll')
          // Re-querying immediately after res.json() guarantees renderContents runs on
          // the live element that is actually in the document.
          var freshCartEl = document.querySelector("cart-drawer") || document.querySelector("cart-notification");

          if (!freshCartEl) {
            console.warn("[PatchPop] Fallback to /cart: neither cart-drawer nor cart-notification found in DOM after fetch.");
          } else if (!hasSectionsToRender) {
            console.warn("[PatchPop] Fallback to /cart: cart element getSectionsToRender is not a function.");
          } else if (!hasRenderContents) {
            console.warn("[PatchPop] Fallback to /cart: cart element renderContents is not a function.");
          } else {
            try {
              // Remove is-empty from <cart-drawer> before renderContents.
              // renderContents removes is-empty from .drawer__inner but NOT from
              // the <cart-drawer> element itself. CartDrawer.open() checks
              // this.classList.contains('is-empty') inside its transitionend callback
              // and, when true, looks for .drawer__inner-empty as the trapFocus container.
              // That element is absent after rendering a non-empty cart, so
              // trapFocus(null) crashes. classList.remove is a no-op when the class is
              // absent, so this is safe for all subsequent adds to a non-empty cart
              // and harmless for cart-notification (which has no is-empty class).
              freshCartEl.classList.remove('is-empty');
              freshCartEl.renderContents(parsedResponse);
              usedNotification = true;
            } catch (notifErr) {
              console.warn("[PatchPop] Fallback to /cart: renderContents threw an error.", notifErr);
            }
          }

          setAtcLoading(atcBtn, false);

          if (!usedNotification) {
            window.location.href = "/cart";
          }
        };

        try {
          await ppbDoAdd();
        } catch (networkErr) {
          console.error("[PatchPop] Add to cart network error:", networkErr);
          showError(errorBox, errorText,
            "Network error — please check your connection and try again.");
          setAtcLoading(atcBtn, false);
        }
        // PATCHPOP END
      });
    }

    // ════════════════════════════════════════════════════════════════════════
    // Helpers (all scoped to this section's closure)
    // ════════════════════════════════════════════════════════════════════════

    function buildComponents(ruleData, state) {
      var components = [];

      ruleData.components.forEach(function (group) {
        var grole = group.role;
        var slots = state.selections[grole] || {};

        if (group.groupType === "base_product") {
          if (slots[1]) {
            components.push({ role: grole, variantId: slots[1], quantity: 1 });
          }
        } else {
          // One entry per slot, each with quantity: 1.
          // The Cart Transform Function merges repeated variants server-side.
          // Do NOT aggregate here — the storefront payload format is one entry per slot.
          Object.keys(slots).forEach(function (s) {
            var gid = slots[s];
            if (gid) {
              components.push({ role: grole, variantId: gid, quantity: 1 });
            }
          });
        }
      });

      return components;
    }

    // ── buildDisplayComponents ────────────────────────────────────────────────
    // Builds a plain pipe-delimited string for _bundle_components_display.
    // Used ONLY by the cart page Liquid for human-readable display.
    // NEVER read by the Cart Transform Function.
    //
    // Format: one line per unique title, joined by the delimiter "||".
    //   "Base T-Shirt / White / XS ×1||Looney Tunes Edition V1 ×2||Arcade Edition V1 ×1"
    //
    // base_product: always ×1, never grouped (only one base slot).
    //   "ProductName / VariantOptions ×1"
    //   - ProductName: read from data-product-title on .ppb-base-product
    //   - VariantOptions: variant.title from ppb-variants-json script tag
    //   - If the variant title is "Default Title", only the product name is shown.
    //
    // patch_theme: grouped by title, quantity = number of slots with that title.
    //   "Looney Tunes Edition V1 ×2"
    //   - Title read from hidden select option's data-title attribute.
    //   - Slots with the same title are counted and emitted as one line.
    //   - Insertion order is preserved (first occurrence determines position).
    //
    // The delimiter "||" is stripped from any title that contains it.
    //
    // Returns the display string on success, null on any failure.
    // A null return means the property is omitted; ATC still works normally.
    //
    function buildDisplayComponents(ruleData, state, sectionEl) {
      try {
        var DELIM = "||";
        var lines = [];

        ruleData.components.forEach(function (group) {
          var grole = group.role;
          var slots = state.selections[grole] || {};

          if (group.groupType === "base_product") {
            // ── Base product: always a single slot, always ×1 ─────────────
            var gid = slots[1];
            if (!gid) return;

            var productTitle = "";
            var variantTitle = "";

            var baseGroupEl = sectionEl.querySelector(
              ".ppb-group--base[data-role='" + grole + "']"
            );
            if (baseGroupEl) {
              var productEl = baseGroupEl.querySelector(".ppb-base-product");
              if (productEl && productEl.dataset.productTitle) {
                productTitle = productEl.dataset.productTitle;
              }

              var scriptEl = baseGroupEl.querySelector(".ppb-variants-json");
              if (scriptEl) {
                try {
                  var variants = JSON.parse(scriptEl.textContent);
                  for (var i = 0; i < variants.length; i++) {
                    if (variants[i].gid === gid) {
                      variantTitle = variants[i].title || "";
                      break;
                    }
                  }
                } catch (_) {}
              }
            }

            var displayTitle;
            if (productTitle && variantTitle && variantTitle !== "Default Title") {
              displayTitle = productTitle + " / " + variantTitle;
            } else if (productTitle) {
              displayTitle = productTitle;
            } else if (variantTitle && variantTitle !== "Default Title") {
              displayTitle = variantTitle;
            } else {
              displayTitle = gid;
            }

            displayTitle = displayTitle.split(DELIM).join(" ");
            lines.push(displayTitle + " \u00D71");

          } else {
            // ── Patch theme: group repeated titles, preserve insertion order ─
            // Pass 1: collect titles in slot order, counting duplicates.
            // titleCounts: { title → count }  (plain object, insertion-ordered in ES2015+;
            //   safe in all browsers since 2016 for string keys)
            var titleCounts  = {};  // title → integer count
            var titleOrder   = [];  // tracks first-seen order

            Object.keys(slots).forEach(function (s) {
              var slotGid = slots[s];
              if (!slotGid) return;

              var numericId  = slotGid.split("/").pop();
              var patchTitle = "";
              var patchGroupEl = sectionEl.querySelector(
                ".ppb-group--patches[data-role='" + grole + "']"
              );
              if (patchGroupEl) {
                var opt = patchGroupEl.querySelector(
                  ".ppb-patch-select[data-slot='" + s + "'] option[value='" + numericId + "']"
                );
                if (opt && opt.dataset.title) {
                  patchTitle = opt.dataset.title;
                }
              }

              if (!patchTitle) return; // skip unresolvable slot

              // Sanitise delimiter
              patchTitle = patchTitle.split(DELIM).join(" ");

              if (titleCounts.hasOwnProperty(patchTitle)) {
                titleCounts[patchTitle] += 1;
              } else {
                titleCounts[patchTitle] = 1;
                titleOrder.push(patchTitle);
              }
            });

            // Pass 2: emit one line per unique title in first-seen order.
            titleOrder.forEach(function (title) {
              var count = titleCounts[title];
              lines.push(title + " \u00D7" + count);
            });
          }
        });

        if (lines.length === 0) return null;
        return lines.join(DELIM);

      } catch (e) {
        console.error("[PatchPop] buildDisplayComponents failed:", e);
        return null;
      }
    }

    function getValidationError(ruleData, state) {
      for (var i = 0; i < ruleData.components.length; i++) {
        var group  = ruleData.components[i];
        var grole  = group.role;
        var slots  = state.selections[grole] || {};
        var filled = Object.keys(slots).filter(function (s) {
          return slots[s] !== null;
        }).length;

        if (filled < group.requiredQty) {
          var remaining = group.requiredQty - filled;
          if (group.groupType === "base_product") {
            return "Please choose your " + grole.replace(/_/g, " ") + ".";
          }
          return remaining === 1
            ? "Choose 1 more patch."
            : "Please choose " + remaining + " more patches.";
        }
      }
      return null;
    }

    function refreshValidationMessage(sectionEl, role, ruleData, state) {
      var msgEl = sectionEl.querySelector("#ppb-val-" + role);
      if (!msgEl) return;

      var group = null;
      for (var i = 0; i < ruleData.components.length; i++) {
        if (ruleData.components[i].role === role) {
          group = ruleData.components[i];
          break;
        }
      }
      if (!group) return;

      var slots     = state.selections[role] || {};
      var filled    = Object.keys(slots).filter(function (s) { return slots[s] !== null; }).length;
      var req       = group.requiredQty;
      var remaining = req - filled;

      if (filled === 0) {
        if (group.groupType === "base_product") {
          msgEl.textContent = "Please choose your " + role.replace(/_/g, " ") + ".";
        } else {
          msgEl.textContent = req === 1
            ? "Please choose a patch."
            : "Please choose " + req + " patches.";
        }
        msgEl.className = "ppb-validation-msg ppb-validation-msg--pending";

      } else if (filled < req) {
        msgEl.textContent = remaining === 1
          ? "Choose 1 more patch."
          : "Choose " + remaining + " more patches.";
        msgEl.className = "ppb-validation-msg ppb-validation-msg--partial";

      } else {
        msgEl.textContent = req + "\u202fof\u202f" + req + " selected \u2713";
        msgEl.className = "ppb-validation-msg ppb-validation-msg--complete";
      }
    }

    function refreshAtcButton(atcBtn, ruleData, state) {
      if (!atcBtn) return;
      var ready = getValidationError(ruleData, state) === null;
      atcBtn.disabled = !ready;
      atcBtn.setAttribute("aria-disabled", String(!ready));
    }

    function setAtcLoading(atcBtn, isLoading) {
      var textEl    = atcBtn.querySelector(".ppb-atc__text");
      var loadingEl = atcBtn.querySelector(".ppb-atc__loading");
      atcBtn.disabled = isLoading;
      if (textEl)    textEl.hidden    = isLoading;
      if (loadingEl) loadingEl.hidden = !isLoading;
      if (!isLoading && textEl) {
        textEl.textContent = atcBtn.dataset.atcLabel || "Add bundle to cart";
        textEl.hidden      = false;
      }
    }

    function markUnavailableOptions(productEl, variants, variantMap, selectedOptions, optionCount) {
      productEl.querySelectorAll(".ppb-option-fieldset").forEach(function (fs) {
        var optIdx = parseInt(fs.dataset.optionIndex, 10);

        fs.querySelectorAll("input[type='radio']").forEach(function (radio) {
          var testParts = [];
          for (var i = 0; i < optionCount; i++) {
            if (i === optIdx) {
              testParts.push(radio.value);
            } else {
              testParts.push(selectedOptions[i] !== null ? selectedOptions[i] : "");
            }
          }
          var testKey   = testParts.join("|");
          var exists    = variantMap.hasOwnProperty(testKey);
          var available = exists && variantMap[testKey].available;

          if (!exists) {
            radio.classList.add("disabled");
            radio.disabled = true;
          } else if (!available) {
            radio.classList.add("disabled");
            radio.disabled = false;
          } else {
            radio.classList.remove("disabled");
            radio.disabled = false;
          }
        });
      });
    }

    // Replaces syncDropdownAvailability for the custom picker.
    // Adds .ppb-picker-option--taken to options chosen in OTHER slots when
    // allowRepeated=false. Never marks options in the slot that just changed.
    function syncPickerAvailability(groupEl, role, changedSlot, state) {
      var takenGids = {};
      Object.keys(state.selections[role]).forEach(function (s) {
        if (parseInt(s, 10) !== changedSlot) {
          var gid = state.selections[role][s];
          if (gid) takenGids[gid] = true;
        }
      });

      groupEl.querySelectorAll(".ppb-patch-slot").forEach(function (slotEl) {
        var thisSlot = parseInt(slotEl.dataset.slot, 10);
        if (thisSlot === changedSlot) return;

        slotEl.querySelectorAll(".ppb-picker-option").forEach(function (li) {
          var gid = li.dataset.gid;
          if (!gid) return;
          var taken = Boolean(takenGids[gid]);
          li.classList.toggle("ppb-picker-option--taken", taken);
          li.setAttribute("aria-disabled", taken ? "true" : "false");
        });
      });
    }

    // Original syncDropdownAvailability kept for reference; not called anymore
    // for patch groups but kept so nothing is accidentally broken if some other
    // code path calls it.
    function syncDropdownAvailability(groupEl, role, changedSlot, state) {
      var takenGids = {};
      Object.keys(state.selections[role]).forEach(function (s) {
        if (parseInt(s, 10) !== changedSlot) {
          var gid = state.selections[role][s];
          if (gid) takenGids[gid] = true;
        }
      });

      groupEl.querySelectorAll(".ppb-patch-select").forEach(function (select) {
        var thisSlot = parseInt(select.dataset.slot, 10);
        if (thisSlot === changedSlot) return;

        Array.from(select.options).forEach(function (opt) {
          if (!opt.value) return;
          var gid = "gid://shopify/ProductVariant/" + opt.value;
          opt.disabled = Boolean(takenGids[gid]);
        });
      });
    }

    // updateTray: reads title and image from the hidden select option by numeric ID.
    // Unchanged from original — the hidden select is still the data source.
    function updateTray(trayEl, groupEl, role, state, reqQty) {
      if (!trayEl) return;
      trayEl.innerHTML = "";
      var hasAny = false;

      for (var slot = 1; slot <= reqQty; slot++) {
        var gid = state.selections[role][slot];
        if (!gid) continue;
        hasAny = true;

        var numericId   = gid.split("/").pop();
        var matchingOpt = groupEl.querySelector(
          ".ppb-patch-select[data-slot='" + slot + "'] option[value='" + numericId + "']"
        );
        var title = matchingOpt ? (matchingOpt.dataset.title || "Patch") : "Patch";
        var img   = matchingOpt ? matchingOpt.dataset.image : null;

        var item        = document.createElement("div");
        item.className  = "ppb-tray-item";
        item.title      = title;

        if (img) {
          var imgEl       = document.createElement("img");
          imgEl.src       = img;
          imgEl.alt       = title;
          imgEl.className = "ppb-tray-img";
          imgEl.width     = 56;
          imgEl.height    = 56;
          item.appendChild(imgEl);
        }

        var labelEl         = document.createElement("span");
        labelEl.className   = "ppb-tray-label";
        labelEl.textContent = title;
        item.appendChild(labelEl);

        trayEl.appendChild(item);
      }

      trayEl.hidden = !hasAny;
    }

    function showError(errorBox, errorText, msg) {
      if (errorBox)  errorBox.hidden = false;
      if (errorText) errorText.textContent = msg;
    }

    function clearError(errorBox) {
      if (errorBox) errorBox.hidden = true;
    }

    // PATCHPOP — poisoned-bundle ADD recovery UI (unique name; do not share
    // with cart.js helpers). Shown only after /cart/add.js returns 422 AND the
    // single retry also returned 422. Renders an explicit message plus a
    // two-step "Empty cart & try again" button into the existing ppb-error box.
    // The cart is NEVER cleared silently — the customer must click, then confirm.
    // Clear uses the locale-aware Shopify routes root; after clearing we reload
    // (we do NOT auto re-add — the customer clicks Add again on a fresh state).
    function ppbShowAddRecovery(errorBox, errorText) {
      if (!errorBox) return;

      var mainMsg =
        "We couldn\u2019t update your cart because one bundle may be outdated. " +
        "To continue, please empty your cart and try again.";
      var warnMsg = "This will remove all items from your cart. Continue?";
      var btnLabel = "Empty cart & try again";

      errorBox.hidden = false;
      if (errorText) errorText.textContent = mainMsg;

      // Avoid stacking duplicate buttons on repeated failures.
      var existing = errorBox.querySelector(".ppb-cart-recovery__btn");
      if (existing) return;

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ppb-cart-recovery__btn button";
      btn.textContent = btnLabel;

      var confirming = false;
      btn.addEventListener("click", function () {
        if (!confirming) {
          confirming = true;
          if (errorText) errorText.textContent = warnMsg;
          return;
        }
        btn.disabled = true;
        btn.textContent = "Emptying\u2026";
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        fetch(root + "cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        })
          .then(function () { window.location.reload(); })
          .catch(function (e) {
            console.error("[PatchPop] cart clear failed:", e);
            btn.disabled = false;
            btn.textContent = btnLabel;
            if (errorText) errorText.textContent =
              "Sorry, that didn\u2019t work. Please refresh the page and try again.";
          });
      });

      errorBox.appendChild(btn);
    }

  }); // end querySelectorAll

})();
